import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {RequestBoxSendComponent} from './requestBoxSend.component';
const routes: Routes = [
  {
    path: '',
    component: RequestBoxSendComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RequestBoxSendRoutingModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/requestBoxSend/requestBoxSend-routing.module.ts